import { getLoginUrl, useSlobAuth } from "client/src/hooks/auth";
import { useClientHubParams } from "client/src/hooks/useClientHubParams";
import { useEffect } from "react";
import { getIsInternalUser } from "shared/rbac/rbac";
import { io } from "socket.io-client";
import type { SocketClient } from "shared/types/Socket";

export const socketClient: SocketClient = io("", {
  autoConnect: false,
  reconnectionAttempts: 5,
  transports: ["websocket", "webtransport"],
});

const useSetUpSocketIO = () => {
  const { clientId } = useClientHubParams();
  const { authUser, refetch: refetchAuth } = useSlobAuth();
  const userId = authUser?.userId;
  const isInternalUser = getIsInternalUser(authUser);

  useEffect(() => {
    if (!userId || !isInternalUser) return;

    socketClient.auth = { clientId, userId };
    socketClient.connect();

    let reauthenticationAttempts = 0;

    socketClient.on("connect_error", async (err) => {
      if (err.message === "Unauthorized") {
        if (reauthenticationAttempts++ < 4) {
          const query = await refetchAuth();
          if (query.status === "success") {
            socketClient.connect();
          } else if (query.status === "error") {
            window.location.href = getLoginUrl();
          }
        }
      }
    });

    return () => {
      socketClient.off("connect_error");
      socketClient.disconnect();
    };
  }, [clientId, userId, refetchAuth, isInternalUser]);
};

// to be the entrypoint to handle the websocket connection and auth
export const WebSocketApp = () => {
  useSetUpSocketIO();
  return null;
};
